import { fDate } from "../utils/formatTime";

export const handleDateRangeBlur = ({
    value,
    fieldName,
    startKey,
    endKey,
    searchdata,
    minDate = new Date(2017, 0, 1),
    today = new Date(),
    setErrorMessage,
    monthrange = 12,
}) => {
    if (!value) {
        return {
            ...searchdata,
            [fieldName]: "",
        };
    }

    const inputDate = new Date(value);
    const isValidDate = inputDate >= minDate && inputDate <= today;
    if (isValidDate)
        setErrorMessage((prev) => ({ ...prev, [fieldName]: "" }));

    let updatedStartDate = searchdata?.[startKey];
    let updatedEndDate = searchdata?.[endKey];

    if (fieldName === startKey) {
        if (isValidDate) {
            updatedStartDate = fDate(value);
            if (updatedEndDate) {
                const start = new Date(updatedStartDate);
                const end = new Date(updatedEndDate);

                const oneYearLater = new Date(start);
                oneYearLater.setMonth(start.getMonth() + monthrange);
                // oneYearLater.setFullYear(start.getFullYear() + 1);

                if (end < start || end > oneYearLater) {
                    updatedEndDate = fDate(
                        oneYearLater <= today ? oneYearLater : today
                    );
                }
            } else {
                const autoEnd = new Date(inputDate);
                autoEnd.setMonth(inputDate.getMonth() + monthrange);
                //autoEnd.setFullYear(inputDate.getFullYear() + 1);

                updatedEndDate = fDate(
                    autoEnd <= today ? autoEnd : today
                );
            }
        }
    }

    if (fieldName === endKey) {
        if (isValidDate) {
            updatedEndDate = fDate(value);

            if (updatedStartDate) {
                const start = new Date(updatedStartDate);
                const end = new Date(updatedEndDate);

                const oneYearBefore = new Date(end);
                // oneYearBefore.setFullYear(end.getFullYear() - 1);
                oneYearBefore.setMonth(end.getMonth() - monthrange);

                if (start > end || start < oneYearBefore) {
                    updatedStartDate = fDate(
                        oneYearBefore >= minDate ? oneYearBefore : minDate
                    );
                }
            } else {
                const autoStart = new Date(inputDate);
                // autoStart.setFullYear(inputDate.getFullYear() - 1);
                autoStart.setMonth(inputDate.getMonth() - monthrange);
                updatedStartDate = fDate(
                    autoStart >= minDate ? autoStart : minDate
                );
            }
        }
    }

    return {
        ...searchdata,
        [startKey]: updatedStartDate,
        [endKey]: updatedEndDate,
    };
};